(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('MessagesPortalController', messagesPortalController)

  messagesPortalController.inject = ['NotificationService', 'MessagesPortalService', 'LangService', '$timeout', 'FoundationApi']

  function messagesPortalController (NotificationService, MessagesPortalService, LangService, $timeout, FoundationApi) {
    var vm = this;
    vm.sendMessage = sendMessage;
    vm.changeMessage = changeMessage;
    vm.checkHasOpenCardBlur = checkHasOpenCardBlur;
    vm.changeDdi = changeDdi;
    vm.fields = {};
    vm.type = '';
    vm.showCpf = false;
    vm.showEPCX = false;
    vm.hsmMessage = '';
    vm.hsmTemplate = '';
    vm.countries = [];
    vm.phoneMask = '';

    LangService
      .getPageLabels({ 'page': 'menu.messagesPortal.messagesSend' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang;
      });

    searchMessage();
    getCountries();
    getCpfValidation();

    function searchMessage () {
      MessagesPortalService
        .getMessages()
        .$promise
        .then(function (data) {
          if (data) {
            vm.messagesTemplate = data.templates;
          }
        }).catch(function (data) {
          NotificationService.errorHandler(data, vm.labels.errorLoadingTemplates);
        });
    }

    function getCountries ()
    {
      MessagesPortalService
        .getCountries()
        .$promise
        .then(function (data) {
          if (data) {
            vm.countries = data.countries;
            getCompanyLocalization();
          }
        }).catch(function (data) {
          NotificationService.errorHandler(data, vm.labels.errorLoadingTemplates);
        });
    }

    function getCompanyLocalization ()
    {
      MessagesPortalService
        .getCompanyLocalization()
        .$promise
        .then(function (data) {
          if (data.value) {
            let localization = JSON.parse(data.value);
            vm.fields.ddi = parseInt(localization.country);

            vm.countries.forEach(function(country, index){
              if (localization.country == country.id) {
                vm.fields.ddi = parseInt(country.ddi);
              }
            });
          } else {
            vm.fields.ddi = 55;
          }

          changeDdi(vm.fields.ddi);
        }).catch(function (data) {
          vm.fields.ddi = 55;
          changeDdi(vm.fields.ddi);
        });
    }

    function changeDdi(ddi)
    {
      vm.countries.forEach(function(country, index){
        if (ddi == country.ddi) {
          vm.phoneMask = country.mask ? country.mask : '';
        }
      });
    }

    async function sendMessage (checkHasOpenCardFlag = true) {
      if (await validateFields(checkHasOpenCardFlag)) {
        if (!checkHasOpenCardFlag) {
          FoundationApi.publish('confirmSendMessageModal', 'close');
        }
        MessagesPortalService
          .sendMessage(vm.fields)
          .$promise
          .then(function (data) {
            if (data.success) {
              NotificationService.successHandler(data, data.message);
              let ddi = vm.fields.ddi;
              vm.fields = {};
              vm.fields.ddi = ddi;
              changeDdi(ddi);
              vm.type = '';
              vm.hsmMessage = '';
              vm.hsmTemplate = '';
            } else if (data.warning) {
              NotificationService.warningHandler(data, data.message);
            } else {
              NotificationService.errorHandler(data, data.message);
            }
          }).catch(function (data) {
            NotificationService.errorHandler(data, vm.labels.errorSendMessage)
          })
      }
    }

    function changeMessage (messageTemplateId) {
      vm.showEPCX = false;
      vm.fields.hsmParams = {}
      vm.fields.message = '';
      vm.type = '';
      vm.hsmTemplate = null;
      for (var property in vm.messagesTemplate) {
        if (messageTemplateId == vm.messagesTemplate[property]['_id']) {
          vm.checkMessageEPCX(vm.messagesTemplate[property]['description']);
          vm.fields.message = vm.messagesTemplate[property]['message'];
          vm.fields.template = vm.messagesTemplate[property];
          vm.type = vm.messagesTemplate[property]['sending_channel']['channel_class'];
          vm.hsmMessage = vm.messagesTemplate[property]['hsm_message']
            ? vm.messagesTemplate[property]['hsm_message']
            : vm.messagesTemplate[property]['message'];

          // timeout para atualizar a diretiva com novo template
          $timeout(function () {

            switch(vm.type)
            {
              case 'App\\Models\\Channels\\SMS':
                vm.hsmTemplate = vm.fields.message;
                break;
              case 'App\\Models\\Channels\\Waent':
                vm.hsmTemplate = vm.hsmMessage.template;
                break;
              default:
                vm.hsmTemplate = vm.hsmMessage.template;
            }
          }, 10)
        }
      }
    }

    async function validateFields (checkHasOpenCardFlag = true) {
      let stone = await stoneageValidation();
      if (stone) {
        NotificationService.warningHandler('', stone)
        return false
      }
      if (vm.fields.phone === undefined || vm.fields.phone === '') {
        NotificationService.warningHandler('', vm.labels.requiredPhone)
        return false
      }

      const phoneIsValid = await isValidPhone();
      if (!phoneIsValid) {
        NotificationService.warningHandler('', vm.labels.invalidPhone)
        return false
      }

      if (vm.fields.messageTemplateId === undefined || vm.fields.messageTemplateId === '') {
        NotificationService.warningHandler('', vm.labels.requiredTemplate)
        return false
      }

      if (vm.showCpf) {
        if (!vm.fields.cpf || vm.fields.cpf === '') {
          NotificationService.warningHandler('', vm.labels.requiredCpf);
          return false;
        }
        const cpfValid = await validateCpf();
        if (!cpfValid) {
          NotificationService.warningHandler('', vm.labels.maxCpfQuantity)
          return false
        }

        const cpfIsValid = await isValidCpf();
        if (!cpfIsValid) {
          NotificationService.warningHandler('', vm.labels.invalidCpf)
          return false
        }
        if (checkHasOpenCardFlag) {
          const hasOpenCard = await checkHasOpenCard();
          if (hasOpenCard) {
            FoundationApi.publish('confirmSendMessageModal', 'open');
            return false;
          }
        }
      }
      const hsmHasEmptyParams = Object.values(vm.fields.hsmParams).filter(f => !f).length
      if (hsmHasEmptyParams) {
        NotificationService.warningHandler('', vm.labels.emptyVariables)
        return false
      }
      return true;
    }

    function getCpfValidation () {
      MessagesPortalService
        .getCpfValidation()
        .$promise
        .then(function (data) {
          if (data.enabled) {
            vm.showCpf = true;
          }
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Erro ao buscar validação de CPF');
        })
    }

    async function validateCpf () {
      try {
        const validation = await MessagesPortalService.validateCpf({
          channel: vm.fields.template.receiving_channel,
          phone: vm.fields.phone,
          cpf: vm.fields.cpf
        }).$promise;

        return validation.valid || false;
      } catch (error) {
        NotificationService.errorHandler('', vm.labels.cpfValidationError)
        console.log(error)
      }
    }

    async function isValidCpf () {
      try {
        const validation = await MessagesPortalService.isValidCpf({
          cpf: vm.fields.cpf
        }).$promise

        return validation.valid || false
      } catch (error) {
        NotificationService.errorHandler('', vm.labels.cpfValidationError)
        console.log(error)
      }
    }

    async function isValidPhone () {
      try {
        const validation = await MessagesPortalService.isValidPhone({
          phone: vm.fields.phone
        }).$promise

        return validation.valid || false
      } catch (error) {
        NotificationService.errorHandler('', vm.labels.phoneValidationError)
      }
    }

    async function checkHasOpenCard () {
      try {
        const validation = await MessagesPortalService.checkHasOpenCard(vm.fields).$promise

        return validation.hasOpenCard || false
      } catch (error) {
        NotificationService.errorHandler('', vm.labels.cpfValidationError)
      }
    }

    /**
     * @returns string
     */
    async function stoneageValidation() {
      try {
        if (!vm.showEPCX) {
          return '';
        }
        let validation = await MessagesPortalService.stoneageValidation({
          cpf: vm.fields.cpf,
          phone_number: vm.fields.phone
        }).$promise
        if (validation.response && validation.response.status == 'APPROVED') {
          return ''
        }
        return validation.descricao ? validation.descricao : vm.labels.stoneageValidation;
      } catch (error) {
        let msg = error.data && error.data.message ? error.data.message : vm.labels.stoneageValidation;
        return msg;
      }
    }

    vm.checkMessageEPCX = message => {
      vm.showEPCX = false;
      if (message.toLowerCase().indexOf('epcx') >= 0) {
        vm.showEPCX = true;
      }
    }

    async function checkHasOpenCardBlur () {
      try {
        if (!vm.fields.phone || !vm.fields.messageTemplateId) {
          return false
        }
        const validation = await MessagesPortalService.checkHasOpenCard(vm.fields).$promise

        if (validation.hasOpenCard) {
          NotificationService.warningHandler('', vm.labels.hasOpenCard)
        }
      } catch (error) {
        NotificationService.errorHandler('', vm.labels.cpfValidationError)
      }
    }
  }
})();
